<template>
  <emd-card>
    <emd-card-header>
      <emd-text size="section"> {{ $t('header') }}</emd-text>
    </emd-card-header>
    <emd-card-content>
      <credit-card
        v-if="data.creditCard"
        :data="data.creditCard"
      />

      <boleto
        v-if="data.boleto"
        :data="data.boleto"
      />

      <pix
        v-if="data.pix"
        :data="data.pix"
      />
    </emd-card-content>
  </emd-card>
</template>

<script>
import {
  EmdText,
  EmdCard,
  EmdCardHeader,
  EmdCardContent
} from 'emerald-vue/src/components'

export default {
  name: 'PaymentMethodsLink',

  components: {
    EmdText,
    EmdCard,
    EmdCardHeader,
    EmdCardContent,

    CreditCard: () => import('./PaymentMethods/CreditCard.vue'),
    Boleto: () => import('./PaymentMethods/Boleto.vue'),
    Pix: () => import('./PaymentMethods/Pix.vue')
  },

  props: {
    data: Object
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "header": "Formas de Pagamento"
    },
    "en-US": {
      "header": "Payment Methods"
    }
  }
</i18n>
